import { toast } from 'vue3-toastify';
import { useLoading } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

let loader = null
const $loading = useLoading()

export const utilFunctionService = {
    setLocalStorageService(keyname, value) {
        localStorage.setItem(keyname, value);
    },

    getLocalStorageService(keyname) {
        if (localStorage.getItem(keyname) !== 'undefined') {
            return JSON.parse(localStorage.getItem(keyname));
        } else {
            return false;
        }
    },

    getAuthToken() {
        if (this.getLocalStorageService('instructor')) {
            return this.getLocalStorageService('instructor').authorization_token;
        } else {
            return false;
        }
    },

    removeLocalStorageService(keyname) {
        localStorage.removeItem(keyname);
    },

    removeSessionStorageService(keyname) {
        sessionStorage.removeItem(keyname);
    },

    showLoader() {
        loader = $loading.show({
            canCancel: true,
            color: '#3dbc9e',
            loader: 'spinner',
            width: 40,
            height: 40
        })
    },

    hideLoader() {
        if (loader) {
            loader.hide()
            loader = null
        }
    },

    showSuccess(message) {
        toast.success(message, {
            autoClose: 5000,
            position: 'top-center',
        })
    },

    showerr(message) {
        toast.error(message, {
            autoClose: 5000,
            position: 'top-center',
        })
    },

    bytesToSize(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
        if (bytes === 0) return 'n/a'
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
        if (i === 0) return `${bytes} ${sizes[i]}`
        return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
      }
}
